(function () {
  'use strict';

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  function toNumericVariantId(value) {
    if (!value) return null;
    var raw = String(value).trim();
    var match = raw.match(/ProductVariant\/(\d+)/);
    if (match) return Number(match[1]);
    var numeric = raw.match(/\d+$/);
    return numeric ? Number(numeric[0]) : null;
  }

  function getServiceLevel(form) {
    var checked = form.querySelector('[data-pw-product-service-level]:checked');
    return checked ? checked.value : 'standard_installation';
  }

  function isAllowedWithThreshold(group) {
    return group === 'delivery' || group === 'perilex' || group === 'gashose' || group === 'recycling';
  }

  function syncGasChoices(form) {
    form.querySelectorAll('[data-pw-gas-choice]').forEach(function (choice) {
      var yes = choice.querySelector('input[type="radio"][value="yes"]:checked');
      var options = choice.querySelector('.pw-gas-options');
      if (!options) return;
      options.hidden = !yes;
      if (!yes) {
        options.querySelectorAll('.pw-service-input').forEach(function (input) {
          input.checked = false;
        });
      }
    });
  }

  function syncServiceLevel(form) {
    var threshold = getServiceLevel(form) === 'threshold';

    form.querySelectorAll('.pw-service-card').forEach(function (card) {
      var input = card.querySelector('.pw-service-input');
      if (!input) return;
      var group = input.dataset.pwServiceGroup || '';
      var allowed = !threshold || isAllowedWithThreshold(group);
      card.hidden = !allowed;
      if (!allowed) input.checked = false;
    });

    form.querySelectorAll('.pw-buybox-options .pw-services').forEach(function (section) {
      var cards = Array.from(section.querySelectorAll('.pw-service-card')).filter(function (card) {
        return Boolean(card.querySelector('.pw-service-input'));
      });
      if (!cards.length) {
        section.hidden = true;
        return;
      }
      section.hidden = !cards.some(function (card) { return !card.hidden; });
    });
  }

  function initProductForm(form) {
    if (form.dataset.pwServicesBound === 'true') return;
    form.dataset.pwServicesBound = 'true';

    form.querySelectorAll('[data-pw-product-service-level]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncServiceLevel(form);
      });
    });

    form.querySelectorAll('[data-pw-gas-choice] input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncGasChoices(form);
        syncServiceLevel(form);
      });
    });

    syncGasChoices(form);
    syncServiceLevel(form);
    form.addEventListener('submit', handleProductSubmit, true);
  }

  function initBuyboxOptions(rootNode) {
    var scope = rootNode || document;

    scope.querySelectorAll('.pw-buybox-options').forEach(function (details) {
      var inputs = Array.from(details.querySelectorAll('.pw-service-input'));
      var optionCount = inputs.filter(function (input) {
        return toNumericVariantId(input.getAttribute('data-pw-service-variant'));
      }).length;
      var hint = details.querySelector('.pw-buybox-options__hint');

      details.hidden = optionCount === 0;
      if (!optionCount) return;

      details.classList.toggle('pw-buybox-options--many', optionCount > 3);
      if (optionCount <= 3) details.open = true;
      if (hint) {
        hint.textContent = optionCount === 1 ? '1 optie' : optionCount + ' opties';
        if (optionCount > 3) hint.textContent += ' beschikbaar';
      }
    });

    scope.querySelectorAll('form.pw-product-form[action*="/cart/add"]').forEach(initProductForm);
  }

  function collectServiceItems(form, bundleId, productTitle, quantity) {
    var items = [];

    form.querySelectorAll('.pw-service-input:checked').forEach(function (input) {
      if (input.closest('[hidden]')) return;

      var variantId = toNumericVariantId(input.dataset.pwServiceVariant || input.value);
      if (!variantId) return;

      var group = input.dataset.pwServiceGroup || '';
      var title = input.dataset.pwServiceTitle || 'Extra service';
      var properties = {
        '_Paulissen extra optie': title,
        '_Servicegroep': group
      };

      if (group === 'recycling') {
        properties['_Paulissen bundel'] = 'algemeen';
        properties['_Paulissen type'] = 'algemeen';
      } else {
        properties['_Paulissen bundel'] = bundleId;
        properties['_Paulissen type'] = 'service';
        properties['Hoort bij'] = productTitle;
      }

      items.push({ id: variantId, quantity: quantity, properties: properties });
    });

    return items;
  }

  async function prepareCartAttributes(bundleId, serviceLevel) {
    try {
      var cartResponse = await fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
      if (!cartResponse.ok) throw new Error('Winkelwagen kon niet worden gelezen.');

      var cart = await cartResponse.json();
      var attributes = Object.assign({}, cart.attributes || {});
      var reviewed = String(attributes.pw_reviewed_bundles || '');
      var tokens = reviewed.split('|').filter(Boolean);
      if (tokens.indexOf(bundleId) === -1) tokens.push(bundleId);

      attributes.pw_service_level = serviceLevel;
      attributes.pw_reviewed_bundles = tokens.length ? '|' + tokens.join('||') + '|' : '';

      var updateResponse = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ attributes: attributes })
      });
      if (!updateResponse.ok) throw new Error('Bezorgkeuze kon niet worden opgeslagen.');
    } catch (error) {
      console.warn('Paulissen: winkelwagenattributen konden niet vooraf worden bijgewerkt.', error);
    }
  }

  async function handleProductSubmit(event) {
    var form = event.currentTarget;
    if (!form || form.dataset.pwSubmitting === 'true') return;

    var formData = new FormData(form);
    var variantId = toNumericVariantId(formData.get('id'));
    var quantity = Math.max(1, Number(formData.get('quantity') || 1));
    var bundleId = 'pw-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    var serviceLevel = getServiceLevel(form);
    var productTitleNode = form.querySelector('[data-pw-product-title]');
    var productTitle = productTitleNode ? productTitleNode.dataset.pwProductTitle : '';
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    form.dataset.pwSubmitting = 'true';

    syncGasChoices(form);
    syncServiceLevel(form);

    var items = [{
      id: variantId,
      quantity: quantity,
      properties: {
        '_Paulissen bundel': bundleId,
        '_Paulissen type': 'hoofdproduct'
      }
    }].concat(collectServiceItems(form, bundleId, productTitle, quantity));

    var submitButton = form.querySelector('[type="submit"]');
    var status = form.querySelector('.pw-service-cart-status');

    if (!status) {
      status = document.createElement('p');
      status.className = 'pw-service-cart-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      if (submitButton) submitButton.insertAdjacentElement('afterend', status);
      else form.appendChild(status);
    }

    status.textContent = '';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    try {
      await prepareCartAttributes(bundleId, serviceLevel);

      var cartDrawer = document.querySelector('cart-drawer');
      var drawerSection = cartDrawer && cartDrawer.closest('.shopify-section');
      var sections = ['cart-icon-bubble'];
      if (drawerSection) sections.push(drawerSection.id.replace('shopify-section-', ''));

      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      });
      var data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'De gekozen opties konden niet worden toegevoegd.');

      status.textContent = 'Toegevoegd aan de winkelwagen.';
      if (cartDrawer && data.sections) {
        cartDrawer.renderContents(data, true);
      } else {
        window.location.href = root + 'cart';
        return;
      }

      document.dispatchEvent(new CustomEvent('on:cart:change'));
      form.dataset.pwSubmitting = 'false';
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    } catch (error) {
      form.dataset.pwSubmitting = 'false';
      status.textContent = error.message || 'De gekozen opties konden niet worden toegevoegd. Controleer uw keuze en probeer opnieuw.';
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initBuyboxOptions(document); });
  } else {
    initBuyboxOptions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBuyboxOptions(event.target);
  });
})();
